import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  PacsRecord: {
    ...genStandard("pacsRecord", "/api/proxy", false),
  },
  Attachment: genStandard("attachment", "/api/store"),
};

export default api;